/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RulesRouteImport } from './routes/rules'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LinksRouteImport } from './routes/links'
import { Route as DomainsRouteImport } from './routes/domains'
import { Route as BlocklistRouteImport } from './routes/blocklist'
import { Route as BillingRouteImport } from './routes/billing'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuditsIndexRouteImport } from './routes/audits.index'
import { Route as LinkIdRouteImport } from './routes/link.$id'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AuditsLinkIdRouteImport } from './routes/audits.$linkId'
import { Route as AuditIdRouteImport } from './routes/audit.$id'

const RulesRoute = RulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LinksRoute = LinksRouteImport.update({
  id: '/links',
  path: '/links',
  getParentRoute: () => rootRouteImport,
} as any)
const DomainsRoute = DomainsRouteImport.update({
  id: '/domains',
  path: '/domains',
  getParentRoute: () => rootRouteImport,
} as any)
const BlocklistRoute = BlocklistRouteImport.update({
  id: '/blocklist',
  path: '/blocklist',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingRoute = BillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditsIndexRoute = AuditsIndexRouteImport.update({
  id: '/audits/',
  path: '/audits/',
  getParentRoute: () => rootRouteImport,
} as any)
const LinkIdRoute = LinkIdRouteImport.update({
  id: '/link/$id',
  path: '/link/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditsLinkIdRoute = AuditsLinkIdRouteImport.update({
  id: '/audits/$linkId',
  path: '/audits/$linkId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditIdRoute = AuditIdRouteImport.update({
  id: '/audit/$id',
  path: '/audit/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/billing': typeof BillingRoute
  '/blocklist': typeof BlocklistRoute
  '/domains': typeof DomainsRoute
  '/links': typeof LinksRoute
  '/login': typeof LoginRoute
  '/rules': typeof RulesRoute
  '/audit/$id': typeof AuditIdRoute
  '/audits/$linkId': typeof AuditsLinkIdRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/link/$id': typeof LinkIdRoute
  '/audits/': typeof AuditsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/billing': typeof BillingRoute
  '/blocklist': typeof BlocklistRoute
  '/domains': typeof DomainsRoute
  '/links': typeof LinksRoute
  '/login': typeof LoginRoute
  '/rules': typeof RulesRoute
  '/audit/$id': typeof AuditIdRoute
  '/audits/$linkId': typeof AuditsLinkIdRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/link/$id': typeof LinkIdRoute
  '/audits': typeof AuditsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/billing': typeof BillingRoute
  '/blocklist': typeof BlocklistRoute
  '/domains': typeof DomainsRoute
  '/links': typeof LinksRoute
  '/login': typeof LoginRoute
  '/rules': typeof RulesRoute
  '/audit/$id': typeof AuditIdRoute
  '/audits/$linkId': typeof AuditsLinkIdRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/link/$id': typeof LinkIdRoute
  '/audits/': typeof AuditsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/billing'
    | '/blocklist'
    | '/domains'
    | '/links'
    | '/login'
    | '/rules'
    | '/audit/$id'
    | '/audits/$linkId'
    | '/auth/callback'
    | '/link/$id'
    | '/audits/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/billing'
    | '/blocklist'
    | '/domains'
    | '/links'
    | '/login'
    | '/rules'
    | '/audit/$id'
    | '/audits/$linkId'
    | '/auth/callback'
    | '/link/$id'
    | '/audits'
  id:
    | '__root__'
    | '/'
    | '/billing'
    | '/blocklist'
    | '/domains'
    | '/links'
    | '/login'
    | '/rules'
    | '/audit/$id'
    | '/audits/$linkId'
    | '/auth/callback'
    | '/link/$id'
    | '/audits/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BillingRoute: typeof BillingRoute
  BlocklistRoute: typeof BlocklistRoute
  DomainsRoute: typeof DomainsRoute
  LinksRoute: typeof LinksRoute
  LoginRoute: typeof LoginRoute
  RulesRoute: typeof RulesRoute
  AuditIdRoute: typeof AuditIdRoute
  AuditsLinkIdRoute: typeof AuditsLinkIdRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  LinkIdRoute: typeof LinkIdRoute
  AuditsIndexRoute: typeof AuditsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/rules': {
      id: '/rules'
      path: '/rules'
      fullPath: '/rules'
      preLoaderRoute: typeof RulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/links': {
      id: '/links'
      path: '/links'
      fullPath: '/links'
      preLoaderRoute: typeof LinksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/domains': {
      id: '/domains'
      path: '/domains'
      fullPath: '/domains'
      preLoaderRoute: typeof DomainsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blocklist': {
      id: '/blocklist'
      path: '/blocklist'
      fullPath: '/blocklist'
      preLoaderRoute: typeof BlocklistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing': {
      id: '/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof BillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audits/': {
      id: '/audits/'
      path: '/audits'
      fullPath: '/audits/'
      preLoaderRoute: typeof AuditsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/link/$id': {
      id: '/link/$id'
      path: '/link/$id'
      fullPath: '/link/$id'
      preLoaderRoute: typeof LinkIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audits/$linkId': {
      id: '/audits/$linkId'
      path: '/audits/$linkId'
      fullPath: '/audits/$linkId'
      preLoaderRoute: typeof AuditsLinkIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit/$id': {
      id: '/audit/$id'
      path: '/audit/$id'
      fullPath: '/audit/$id'
      preLoaderRoute: typeof AuditIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BillingRoute: BillingRoute,
  BlocklistRoute: BlocklistRoute,
  DomainsRoute: DomainsRoute,
  LinksRoute: LinksRoute,
  LoginRoute: LoginRoute,
  RulesRoute: RulesRoute,
  AuditIdRoute: AuditIdRoute,
  AuditsLinkIdRoute: AuditsLinkIdRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  LinkIdRoute: LinkIdRoute,
  AuditsIndexRoute: AuditsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
